import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useBackend } from '@/composables'

export const useMetricsStore = defineStore('metrics', () => {
  const hasManualMetrics = ref(false)
  const loaded = ref(false)

  const { items, getItems } = useBackend('payroll/pos-metrics')

  async function checkManualMetrics() {
    if (loaded.value) return

    try {
      await getItems({
        Filter: '[source]Manual,[isActive]true',
        PageSize: 1
      })
      hasManualMetrics.value = items.value?.length > 0
      loaded.value = true
    } catch (e) {
      // Silently fail - default to no manual metrics
      hasManualMetrics.value = false
      loaded.value = true
    }
  }

  function reset() {
    hasManualMetrics.value = false
    loaded.value = false
  }

  return {
    hasManualMetrics,
    loaded,
    checkManualMetrics,
    reset
  }
})
